import { RadioOption } from '@zuto/atoms'

export const rankedAddressSituationOptions: RadioOption[] = [
  {
    value: 'private tenant',
    label: 'Private Tenant'
  },
  {
    value: 'living with parents',
    label: 'Living with parents'
  },
  {
    value: 'council tenant',
    label: 'Council Tenant'
  },
  {
    value: 'homeowner',
    label: 'Homeowner'
  },
  {
    value: 'living with partner',
    label: 'Living with partner'
  }
]

export default rankedAddressSituationOptions
